var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffd900",
    r: 4,
    cy: 50,
    cx: 60
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.67s",
    keyTimes: "0;1",
    values: "95;35",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.67s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "fill-opacity"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffd900",
    r: 4,
    cy: 50,
    cx: 60
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.33s",
    keyTimes: "0;1",
    values: "95;35",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.33s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "fill-opacity"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffd900",
    r: 4,
    cy: 50,
    cx: 60
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keyTimes: "0;1",
    values: "95;35",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "cx"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "fill-opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 50 50)",
    fill: "#ffd900",
    d: "M50 50L20 50A30 30 0 0 0 80 50Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M50 50L20 50A30 30 0 0 0 80 50Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;0.5;1",
    values: "0 50 50;45 50 50;0 50 50",
    dur: "1s",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M50 50L20 50A30 30 0 0 1 80 50Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;0.5;1",
    values: "0 50 50;-45 50 50;0 50 50",
    dur: "1s",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacman);
export default __webpack_public_path__ + "static/media/pacman.f5693a6a7d0879ef595d20ab1b1cee57.svg";
export { ForwardRef as ReactComponent };